import React, { useState, Children } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showAdvertorialModal, setShowAdvertorialModal] = useState(false);
  return <>
      <footer className="border-t border-gray-200 bg-gray-50 mt-16" data-id="element-1025">
        <div className="max-w-7xl mx-auto px-4 py-8" data-id="element-1026">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1027">
            <div className="text-sm text-gray-600" data-id="element-1028">
              © 2025 NewsBreak. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-6 text-sm" data-id="element-1029">
              
              <button onClick={() => setShowPrivacyModal(true)} className="text-gray-600 hover:text-gray-900 underline decoration-gray-400" data-id="element-1030">
                Privacy Policy
              </button>
              <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-1031">
                Terms of Service
              </a>
              
            </div>
          </div>
        </div>
      </footer>

      {/* Advertorial Modal */}
      {showAdvertorialModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-1032">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" data-id="element-1033">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center" data-id="element-1034">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-1035">
                Advertorial Disclosure
              </h2>
              <button onClick={() => setShowAdvertorialModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1036">
                <X className="w-6 h-6" data-id="element-1037" />
              </button>
            </div>
            <div className="px-6 py-6 space-y-4 text-gray-700 leading-relaxed" data-id="element-1038">
              <p className="font-semibold text-gray-900" data-id="element-1039">
                Important Notice: This is Sponsored Content
              </p>
              <p data-id="element-1040">
                This article is an advertorial and has been created in
                partnership with HEYLLOYD. The content, opinions, and
                recommendations expressed in this article are those of the
                sponsor and do not necessarily reflect the views of NewsBreak or
                its editorial team.
              </p>
              <p data-id="element-1041">
                <strong data-id="element-1042">What is an Advertorial?</strong>
                <br data-id="element-1043" />
                An advertorial is a form of advertisement designed to look and
                read like editorial content. While we strive to maintain
                transparency, advertorials are paid content created to promote a
                product, service, or brand.
              </p>
              <p data-id="element-1044">
                <strong data-id="element-1045">Our Commitment to Transparency:</strong>
                <br data-id="element-1046" />
                NewsBreak is committed to clearly distinguishing between
                editorial content and sponsored content. All advertorials are
                clearly marked and disclosed to our readers. We maintain
                editorial independence and do not allow sponsors to influence
                our independent journalism.
              </p>
              <p data-id="element-1047">
                <strong data-id="element-1048">Compensation Disclosure:</strong>
                <br data-id="element-1049" />
                NewsBreak receives compensation for publishing this advertorial
                content. This compensation may include direct payment, affiliate
                commissions, or other forms of consideration. Any links to
                external websites may be affiliate links where we earn a
                commission on qualifying purchases or actions.
              </p>
              <p data-id="element-1050">
                <strong data-id="element-1051">Your Responsibility:</strong>
                <br data-id="element-1052" />
                We encourage readers to conduct their own research and due
                diligence before making any purchasing decisions based on
                advertorial content. The information provided is for
                informational purposes only and should not be considered
                professional advice.
              </p>
              <p className="text-sm text-gray-600 border-t border-gray-200 pt-4 mt-4" data-id="element-1053">
                Last updated: January 2025
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Policy Modal */}
      {showPrivacyModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-1054">
          <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" data-id="element-1055">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center" data-id="element-1056">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-1057">
                Privacy Policy
              </h2>
              <button onClick={() => setShowPrivacyModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1058">
                <X className="w-6 h-6" data-id="element-1059" />
              </button>
            </div>
            <div className="px-6 py-6 space-y-4 text-gray-700 leading-relaxed" data-id="element-1060">
              <p className="font-semibold text-gray-900" data-id="element-1061">
                Effective Date: January 1, 2025
              </p>

              <div className="space-y-4" data-id="element-1062">
                <section data-id="element-1063">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1064">
                    1. Information We Collect
                  </h3>
                  <p data-id="element-1065">
                    We collect information you provide directly to us, such as
                    when you create an account, subscribe to our newsletter, or
                    interact with our content. This may include your name, email
                    address, location preferences, and reading history.
                  </p>
                </section>

                <section data-id="element-1066">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1067">
                    2. How We Use Your Information
                  </h3>
                  <p data-id="element-1068">We use the information we collect to:</p>
                  <ul className="list-disc list-inside ml-4 space-y-1" data-id="element-1069">
                    <li data-id="element-1070">Provide, maintain, and improve our services</li>
                    <li data-id="element-1071">Personalize your content experience</li>
                    <li data-id="element-1072">Send you newsletters and updates</li>
                    <li data-id="element-1073">Analyze usage patterns and trends</li>
                    <li data-id="element-1074">Detect and prevent fraud or abuse</li>
                  </ul>
                </section>

                <section data-id="element-1075">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1076">
                    3. Information Sharing
                  </h3>
                  <p data-id="element-1077">
                    We do not sell your personal information. We may share your
                    information with:
                  </p>
                  <ul className="list-disc list-inside ml-4 space-y-1" data-id="element-1078">
                    <li data-id="element-1079">Service providers who assist in our operations</li>
                    <li data-id="element-1080">Analytics partners to understand usage patterns</li>
                    <li data-id="element-1081">Law enforcement when required by law</li>
                    <li data-id="element-1082">Business partners with your explicit consent</li>
                  </ul>
                </section>

                <section data-id="element-1083">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1084">
                    4. Cookies and Tracking
                  </h3>
                  <p data-id="element-1085">
                    We use cookies and similar tracking technologies to collect
                    information about your browsing activities. You can control
                    cookies through your browser settings, though some features
                    may not function properly if cookies are disabled.
                  </p>
                </section>

                <section data-id="element-1086">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1087">
                    5. Your Rights
                  </h3>
                  <p data-id="element-1088">You have the right to:</p>
                  <ul className="list-disc list-inside ml-4 space-y-1" data-id="element-1089">
                    <li data-id="element-1090">Access and review your personal information</li>
                    <li data-id="element-1091">Request correction of inaccurate data</li>
                    <li data-id="element-1092">Request deletion of your data</li>
                    <li data-id="element-1093">Opt-out of marketing communications</li>
                    <li data-id="element-1094">Export your data in a portable format</li>
                  </ul>
                </section>

                <section data-id="element-1095">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1096">
                    6. Data Security
                  </h3>
                  <p data-id="element-1097">
                    We implement reasonable security measures to protect your
                    information from unauthorized access, alteration, or
                    destruction. However, no internet transmission is completely
                    secure, and we cannot guarantee absolute security.
                  </p>
                </section>

                <section data-id="element-1098">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1099">
                    7. Children's Privacy
                  </h3>
                  <p data-id="element-1100">
                    Our services are not directed to children under 13. We do
                    not knowingly collect personal information from children
                    under 13. If you believe we have collected such information,
                    please contact us immediately.
                  </p>
                </section>

                <section data-id="element-1101">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1102">
                    8. Changes to This Policy
                  </h3>
                  <p data-id="element-1103">
                    We may update this privacy policy from time to time. We will
                    notify you of any material changes by posting the new policy
                    on this page and updating the effective date.
                  </p>
                </section>

                <section data-id="element-1104">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1105">
                    9. Contact Us
                  </h3>
                  <p data-id="element-1106">
                    If you have questions about this privacy policy or our data
                    practices, please contact us at:
                  </p>
                  <p className="ml-4 mt-2" data-id="element-1107">
                    Email: privacy@newsbreak.com
                    <br data-id="element-1108" />
                    Address: 123 News Street, San Francisco, CA 94102
                  </p>
                </section>
              </div>

              <p className="text-sm text-gray-600 border-t border-gray-200 pt-4 mt-6" data-id="element-1109">
                Last updated: January 2025
              </p>
            </div>
          </div>
        </div>}
    </>;
}